/**** mgt.Holidays */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'mgt',
  table: 'Holidays',
  title: 'Праздничные дни',
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  connections: {
    route: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'Routes',
      index: 'route_id',
      fields: ['route_short_name'],
      format: (elem: any) => elem['route_short_name'],
      autocomplete: true,
    },
  },
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'route_id',
      title: 'Маршрут',
      type: 'number',
      required: false,
      connection: 'route',
    },
    {
      name: 'date',
      title: 'Дата',
      type: 'date',
      required: true,
    },
    {
      name: 'dow',
      title: 'День недели, по которому работает транспорт',
      type: 'list',
      required: true,
      values: [
        { key: null, value: 'Любой день' },
        { key: 1, value: 'Понедельник' },
        { key: 2, value: 'Вторник' },
        { key: 3, value: 'Среда' },
        { key: 4, value: 'Четверг' },
        { key: 5, value: 'Пятница' },
        { key: 6, value: 'Суббота' },
        { key: 0, value: 'Воскресенье' },
      ],
    },
    {
      name: 'do_not_update',
      title: 'Отключить автообновление',
      type: 'boolean',
      required: false,
      width: '205px',
    },
  ],
  newTemplate: {
    id: null,
    route_id: null,
    date: null,
    dow: null,
    do_not_update: true,
  },
  updateField: 'update_date',
  defaultSort: {
    field: 'id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'route_id',
        field: 'route_id',
      },{
        title: 'date',
        field: 'date',
      },{
        title: 'dow',
        field: 'dow',
      }
    ],
    example: `1;2020-01-01;0`,
    insertOnly: true,
  },
  export: {
    fields: [
      {
        name: 'route_id',
        title: 'Маршрут',
        connectionGetField: 'route_short_name'
      },
      {
        name: 'vehicle_type',
        title: 'Тип ТС',
        connection: 'vehicle_type',
        connectionField: 'route_id',
      },
      {
        name: 'date',
        title: 'Дата',
        type: 'date'
      },
      {
        name: 'dow',
        title: 'День недели, по которому работает транспорт',
        format: {
          fields: ['dow'],
          template: '%1',
          values: {
            'null': 'Любой день',
            '1': 'Понедельник',
            '2': 'Вторник',
            '3': 'Среда',
            '4': 'Четверг',
            '5': 'Пятница',
            '6': 'Суббота',
            '0': 'Воскресенье',
          }
        }
      },
    ],
    connections: {
      vehicle_type: {
        index: 'route_id',
        customsql:
          `
            SELECT
                r.route_short_name
            FROM
                mgt."Holidays" h
            INNER JOIN
                mgt."Routes" r ON h.route_id = r.route_id
            INNER JOIN
                mgt."Agency" ag ON r."Agency_id" = ag.agency_id
            INNER JOIN
                mgt."Depot" dp ON ag.agency_id = dp.agency_id
            INNER JOIN
                mgt."Vehicle" v ON dp.depot_id = v.depot_id
          `,
      },
    }
  }
};

export default config;
